export const blockIconsDeviceDarkMode = (
	<span className='material-symbols-outlined'>dark_mode</span>
);
